<div class="filters">
  <input [(ngModel)]="element" placeholder="Elemento (e.g. pixel-exportadores-argentina)" />
  <input type="date"       [(ngModel)]="start"   />
  <input type="date"       [(ngModel)]="end"     />
  <button (click)="loadAndDraw()">Aplicar filtros</button>
</div>

<div id="map" style="height: 500px;"></div>
